module.exports = __webpack_public_path__ + "logo-shoper-blue.ce136d15b937eb54ba05c88dc621f237.svg";